import TeamEdit from '@/screens/TeamEdit';

export default function PrivateTeamCreateIndexRoute() {
  return <TeamEdit />;
}
